import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import AuthShell, { Field, inputClass } from "@/components/AuthShell";
import { PrimaryButton } from "@/components/kit";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email.trim(), password);
      const dest = location.state?.from?.pathname || "/app";
      navigate(user.role === "vet" ? "/app/vet-dashboard" : dest, { replace: true });
    } catch (err) {
      toast.error(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Log in to keep your pup happy and healthy."
      footer={
        <>
          Don&apos;t have an account?{" "}
          <Link to="/signup" className="font-bold text-[#E86A45]">Sign up</Link>
        </>
      }
    >
      <form onSubmit={submit}>
        <Field label="Email">
          <input
            data-testid="login-email-input"
            type="text"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className={inputClass}
          />
        </Field>
        <Field label="Password">
          <div className="relative">
            <input
              data-testid="login-password-input"
              type={show ? "text" : "password"}
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Your password"
              className={inputClass + " pr-12"}
            />
            <button
              type="button"
              data-testid="login-toggle-password"
              onClick={() => setShow((s) => !s)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[#9A938B] hover:text-[#4A4746]"
            >
              {show ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>
        </Field>
        <div className="text-right -mt-1 mb-4">
          <Link to="/forgot-password" data-testid="login-forgot-link" className="text-sm font-bold text-[#6F8F72]">
            Forgot password?
          </Link>
        </div>
        <PrimaryButton data-testid="login-submit-btn" type="submit" loading={loading} className="w-full">
          Log in
        </PrimaryButton>
      </form>
    </AuthShell>
  );
}
